import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingBlurEffectConfig } from '@/data/landingConfig/landingBlurEffectConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_BlurEffect } from './schemaObject';

interface Props {}
const BlurEffect: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_BlurEffect} />
			<LandingTemplate
				data={landingBlurEffectConfig}
				funnelLinkService={GenerateLandingLinkService.funnelBlur()}
			/>
		</>
	);
};

export default BlurEffect;
